import { ModelBase } from '../../core/model/model-base';
import { CustomProperty } from './custom-property';
import { LocalDate } from '../../core/model/local-date';
import { CustomPropertyDataType } from './const/enums';

export class ObjectComponentPropertyValue extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.customProperty = dataContext.customProperty;
      if (dataContext.customProperty && dataContext.customProperty.dataType) this.dataType = dataContext.customProperty.dataType;
      this.boolValue = dataContext.boolValue;
      this.textValue = dataContext.textValue;
      this.numericValue = dataContext.numericValue;
      this.dateValue = dataContext.dateValue;
      this.mandatory = dataContext.mandatory;
    }
  }
  customProperty: CustomProperty | string;
  mandatory: boolean;
  boolValue: boolean;
  textValue: string;
  numericValue: number;
  dateValue: LocalDate;
  dataType: CustomPropertyDataType;
  toJSON() {
    return {
      id: this.id,
      customProperty:
        typeof this.customProperty === 'string' ? (this.customProperty as string) : this.customProperty ? this.customProperty.id : null,
      boolValue: this.boolValue,
      textValue: this.textValue,
      numericValue: this.numericValue,
      dateValue: this.dateValue,
      mandatory: this.mandatory,
      dataType: this.dataType,
    };
  }
}
